import _ from 'lodash';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { REDACTED_FIELD } from '../../../../config/logrocket';

const EndorsementHeader = ({ data, readOnly = true }: any) => {
  const classes = useStyles();
  const { companyName, naicsCode, primaryIndustry } = data;

  return (
    <Grid container>
      <Grid item md={!readOnly ? 10 : 12}>
        <h2 className={classes.heading}>
          Midterm Endorsement for{' '}
          <span className={REDACTED_FIELD}>{companyName}</span>
        </h2>
        <h2 className={classes.subHeading}>
          {naicsCode}:{' '}
          {_.get(primaryIndustry, 'length', 0) < 73
            ? primaryIndustry
            : `${primaryIndustry.substr(0, 67)}...`}
        </h2>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  heading: {
    textAlign: 'center',
    color: palette.text.secondary,
    fontSize: config.textSizes.canon,
    fontWeight: config.weights.bold,
    margin: 0,
    lineHeight: 1.13,
  },

  subHeading: {
    textAlign: 'center',
    color: palette.text.secondary,
    fontSize: config.textSizes.primer,
    fontWeight: config.weights.bold,
    margin: '0',
    lineHeight: 1.69,
  },
}));

export default EndorsementHeader;
